import React, { useReducer } from "react";
import NavigationContext from "./NavigationContext";
import NavigationReducer from "./NavigationReducer";
import {
  SET_CURRENT_NAVIGATION,
  NAVIGATIONS_RESET,
  SET_FIELD_REFS,
  AUTORUN_BANNER,
} from "../types";

const NavigationState = (props) => {
  const initialState = {
    navigationTo: "",
    navigationBack: false,
    fieldRefs: null,
    autorunBanner: true,
    cartAction: "",
  };
  const [state, dispatch] = useReducer(NavigationReducer, initialState);

  //Reset Context State
  const resetNavigationState = () => {
    dispatch({
      type: NAVIGATIONS_RESET,
      payload: { ...initialState },
    });
  };

  //Set Cart Action
  const setCartAction = (action) => {
    dispatch({
      type: SET_CURRENT_NAVIGATION,
      payload: { cartAction: action },
    });
  };

  //Set Target Page
  const setNavigationPage = (navigationTo) => {
    dispatch({
      type: SET_CURRENT_NAVIGATION,
      payload: { navigationTo, navigationBack: true },
    });
  };

  //Set Feild References
  const setFieldRefs = (fieldRefs) => {
    dispatch({
      type: SET_FIELD_REFS,
      payload: { fieldRefs },
    });
  };

  //Set Banner Autorun
  const setAutorunBanner = (autorunBanner) => {
    dispatch({
      type: AUTORUN_BANNER,
      payload: { autorunBanner },
    });
  };

  return (
    <NavigationContext.Provider
      value={{
        ...state,
        resetNavigationState,
        setNavigationPage,
        setFieldRefs,
        setAutorunBanner,
        setCartAction,
      }}
    >
      {props.children}
    </NavigationContext.Provider>
  );
};

export default NavigationState;
